import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "../components/ui/button";

export const Login = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user, loading, loginWithPassword, accessDenied, deniedEmail, logout, clearAccessDenied } = useAuth();
  const isDenied = searchParams.get("denied") === "true" || accessDenied;

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!loading && user && !isDenied) {
      navigate("/", { replace: true });
    }
  }, [user, loading, navigate, isDenied]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const result = await loginWithPassword(email.trim(), password);
    setSubmitting(false);
    if (result.success) {
      navigate("/", { replace: true });
    } else if (result.reason === "access_denied") {
      setError("Цей email не має доступу до панелі.");
    } else if (result.reason === "invalid_password") {
      setError("Невірний пароль.");
    } else {
      setError("Помилка входу. Спробуйте ще раз.");
    }
  };

  const handleLogout = async () => {
    await logout();
    clearAccessDenied();
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-[#B5331B] border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (isDenied) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center p-4">
        <div className="w-full max-w-md">
          <div className="bg-[#121212] border border-[#262626] p-8 text-center">
            <div className="mb-8">
              <h1 className="text-3xl font-black uppercase tracking-tight">
                <span className="text-[#B5331B]">Poli</span>
                <span className="text-[#EDEDED]">Best</span>
                <span className="text-[#737373] ml-2">911</span>
              </h1>
            </div>
            <div className="mb-8">
              <div className="w-16 h-16 bg-[#7F1D1D]/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-[#B5331B]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
                </svg>
              </div>
              <h2 className="text-xl font-bold text-[#EDEDED] uppercase mb-2">Доступ заборонено</h2>
              <p className="text-[#A3A3A3] text-sm mb-2">Цей email не має доступу до панелі.</p>
              {deniedEmail && (
                <p className="text-[#737373] text-xs font-mono">{deniedEmail}</p>
              )}
            </div>
            <Button
              onClick={handleLogout}
              className="w-full bg-[#262626] hover:bg-[#333] text-[#EDEDED] py-4 font-bold uppercase tracking-wider"
            >
              Назад
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-[#121212] border border-[#262626] p-8">
          <div className="text-center mb-8">
            <h1 className="text-4xl font-black uppercase tracking-tight mb-2">
              <span className="text-[#B5331B]">Poli</span>
              <span className="text-[#EDEDED]">Best</span>
              <span className="text-[#737373] ml-2">911</span>
            </h1>
            <p className="text-[#737373] text-sm uppercase tracking-wider">
              Полімерні покриття
            </p>
          </div>

          <div className="border-t border-[#262626] my-6"></div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-[#A3A3A3] text-xs uppercase tracking-wider mb-1">
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                className="w-full bg-[#1A1A1A] border border-[#262626] text-[#EDEDED] px-4 py-3 text-sm focus:outline-none focus:border-[#B5331B] transition-colors"
                placeholder="your@email.com"
              />
            </div>

            <div>
              <label className="block text-[#A3A3A3] text-xs uppercase tracking-wider mb-1">
                Пароль
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
                className="w-full bg-[#1A1A1A] border border-[#262626] text-[#EDEDED] px-4 py-3 text-sm focus:outline-none focus:border-[#B5331B] transition-colors"
                placeholder="••••••••"
              />
            </div>

            {error && (
              <p className="text-[#B5331B] text-sm text-center">{error}</p>
            )}

            <Button
              type="submit"
              disabled={submitting}
              className="w-full bg-[#B5331B] hover:bg-red-700 text-white py-4 font-bold uppercase tracking-wider"
            >
              {submitting ? "Вхід..." : "Увійти"}
            </Button>
          </form>
        </div>

        <p className="text-center text-[#3A3A3A] text-xs mt-4">
          © 2025 PoliBest 911. Всі права захищені.
        </p>
      </div>
    </div>
  );
};

export default Login;
